import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <pre className="terms-text">
        <h1>TERMS & CONDITIONS</h1>
{`1. Order Policy
Minimum Order Quantity (MOQ): 50 sets per product.
Bulk and institutional orders (above 50 sets) qualify for special rates and priority delivery.
Once an order is confirmed, any changes or modifications must be communicated within 48 hours and are subject to approval.

2. Delivery & Lead Time
Standard delivery timeline: 30 days from the date of order confirmation and receipt of full payment.
Delivery timelines may vary depending on stock availability, order volume, and logistics conditions.
Recla will not be liable for delays caused by courier services, customs, or transportation strikes.

3. Payment Terms
100% advance payment is required before the dispatch of goods.
Orders will be processed only after payment confirmation via bank transfer
Any delay in payment will directly impact the delivery schedule.

4. Pricing
All prices are exclusive of freight, and packaging, unless mentioned otherwise.
Prices are subject to change without prior notice due to market fluctuations, import duties, or raw material cost changes.

5. Cancellation Policy
Orders once confirmed cannot be cancelled or refunded.
Only minor modifications (like address change or contact update) will be allowed within 48 hours of placing the order.

6. Return & Replacement Policy
Returns are accepted only in case of manufacturing defects or incorrect dispatch.
Issues must be reported within 48 hours of delivery with clear photo/video evidence.
Replacement or credit will be issued only after inspection and verification by Recla’s technical team.
No returns will be accepted for damages caused during handling, installation, or due to improper printer usage.

7. Product Warranty
All Recla toner cartridges are tested and quality-checked before dispatch.
Warranty covers manufacturing defects only and does not include wear & tear, mishandling, or use with incompatible devices.
Any warranty claims must include an invoice copy and a defect proof for processing.

8. Shipping & Handling
Shipping is arranged by Recla or the buyer, depending on the agreed terms.
Ownership and risk transfer to the buyer once the goods are handed over to the courier/transporter.
Clients are advised to check packages upon delivery and immediately notify Recla in case of visible damage.

9. Bulk / Institutional Orders
For orders above 50 sets, special pricing and terms can be discussed with the Recla sales team.
Bulk orders may require extended production timelines, and delivery will be confirmed at the time of payment.

10. Limitation of Liability
Recla’s liability is limited strictly to the replacement or credit of defective products.
Recla is not liable for any indirect, consequential, or incidental damages caused by product usage or printer malfunction.

11. Governing Law
All transactions are governed under the laws of India and Nigeria.
Any disputes shall be subject to the jurisdiction of the Mumbai and Indian courts.`}
      </pre>
    </div>
  );
};

export default TermsAndConditions;
